__webpack_require__.p = "https://cdn.dotpe.in/ds_assets/e2b7281fb7695b6787f8615223b67734d104915f/_next/";